module.exports = __webpack_public_path__ + "img/PPT.3cd6f3ed.png";